import { createSlice } from "@reduxjs/toolkit";
import {
  deleteFeedbacks,
  singleFeedbacks,
  viewFeedbacks,
  sendMessage,
} from "../actions/feedbackAction";

const feedbackSlice = createSlice({
  name: "feedback",
  initialState: {
    feedback: null,
    loading: false,
    error: null,
    success: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(viewFeedbacks.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(viewFeedbacks.fulfilled, (state, action) => {
        state.loading = false;
        state.feedback = action.payload;
      })
      .addCase(viewFeedbacks.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
  extraReducers: (builder) => {
    builder
      .addCase(sendMessage.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(sendMessage.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.feedback = action.payload;
      })
      .addCase(sendMessage.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },

  extraReducers: (builder) => {
    builder
      .addCase(deleteFeedbacks.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteFeedbacks.fulfilled, (state, action) => {
        state.loading = false;
        state.feedback = action.payload;
      })
      .addCase(deleteFeedbacks.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
  extraReducers: (builder) => {
    builder
      .addCase(singleFeedbacks.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(singleFeedbacks.fulfilled, (state, action) => {
        state.loading = false;
        state.feedback = action.payload;
      })
      .addCase(singleFeedbacks.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default feedbackSlice.reducer;
